import { render, staticRenderFns } from "./CookiesPage.vue?vue&type=template&id=fddce38e&scoped=true&"
import script from "./CookiesPage.vue?vue&type=script&lang=js&"
export * from "./CookiesPage.vue?vue&type=script&lang=js&"
import style0 from "./CookiesPage.vue?vue&type=style&index=0&id=fddce38e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddce38e",
  null
  
)

export default component.exports